/* Click-to-play YouTube facade: one delegated listener; the iframe loads only after a click. */
(function () {
  'use strict';
  if (window.__clYoutubeFacade) return;
  window.__clYoutubeFacade = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cl-yt] .cl-yt__play');
    if (!button) return;
    var root = button.closest('[data-cl-yt]');
    var id = root.dataset.videoId;
    if (!id) return;
    event.preventDefault();
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = root.dataset.videoTitle || 'Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    root.replaceChildren(iframe);
    // keep keyboard/screen-reader focus on the player that replaced the button
    iframe.focus();
  });
})();
